(function () {
  function initFaq(root) {
    if (!root || root.dataset.sdInit === '1') return;
    root.dataset.sdInit = '1';
    var items = root.querySelectorAll('.sd-faq__item');
    items.forEach(function (item) {
      var btn = item.querySelector('.sd-faq__q');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var wasOpen = item.classList.contains('is-open');
        items.forEach(function (i) {
          i.classList.remove('is-open');
          var b = i.querySelector('.sd-faq__q');
          if (b) b.setAttribute('aria-expanded', 'false');
        });
        if (!wasOpen) {
          item.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  function bootstrap() {
    document.querySelectorAll('[data-sd-faq]').forEach(initFaq);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-sd-faq]');
    if (root) initFaq(root);
  });
})();
